import {Component} from '@angular/core';
import {ModalBaseComponent} from '~shared/ng/components/dialog/base/modal-base.component';
import {NgIf} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule} from '@angular/forms';
import {RouterLink} from '@angular/router';
import {ValidationCssDirective} from '~shared/ng/modules/validation/directives/validation/validation-css.directive';
import {ValidationErrorComponent} from '~shared/ng/modules/validation/components/validation/validation-error.component';
import {provideValidationWithRules, ValidationModule} from '~shared/ng/modules/validation/validation.module';
import {formDisabledSourceProvider} from '~shared/ng/modules/validation/directives/utils/form-disabled.directive';
import {RequiredRule} from '~shared/ng/modules/validation/rules/rules';
import {ValidationSubmitEvent} from '~shared/ng/modules/validation/directives/check/validation-check-base.directive';

type AuthForm = {
    otpAuthPassword: string,
};

@Component({
    standalone: true,
    selector: 'app-otp-auth-dialog',
    templateUrl: './otp-auth-dialog.component.html',
    viewProviders: [
        formDisabledSourceProvider,
    ],
    providers: [
        provideValidationWithRules({
            otpAuthForm: {
                otpAuthPassword: [new RequiredRule()],
            },
        })
    ],
    imports: [
        ValidationModule,
        FormsModule,
        ValidationErrorComponent,
        NgIf,
        RouterLink,
        TranslateModule,
        ValidationCssDirective
    ]
})
export class OtpAuthDialogComponent extends ModalBaseComponent<{}, AuthForm> {
    public showPassword: boolean = false;

    public submit($event: ValidationSubmitEvent<AuthForm>): void {
        this.close($event.formData);
    }
}
